import React, { useCallback, useEffect, useState } from 'react';
import profileApi from '../../apis/profile-api';
import formatCurrency from '../../utils/format-currency';

function RevenueItem({ affiliateData, currentTab }) {
  const [affiliate, setAffiliate] = useState({});
  const [affiliateStats, setAffiliateStats] = useState({
    numOfDeal: 0,
    numOfLead: 0,
    actualCommission: 0,
    revenue: 0
  });

  const calcRevenuePercent = useCallback((contractType) => {
    switch (contractType) {
      case 'direct':
        return 17;
      default:
        return 12;
    }
  }, []);

  useEffect( () => {
    const getAffiliate = async() => {
      const affiliate_id = Object.keys(affiliateData)[0];
      const { data } = await profileApi.getAffiliateById(+affiliate_id);
      setAffiliate(data);
    };
    getAffiliate();
  }, [affiliateData]);

  useEffect(() => {
    let actualRevenue = 0;
    let deal = 0;
    let lead = 0;

    if (affiliateData) {
      const formatData = Object.values(affiliateData)[0];
      for (let item of formatData) {
        if (item.is_converted === true) {
          deal++;
        } else {
          lead++;
        }

        if (item.deal_stage === 'Closed Won') {
          actualRevenue += item.lead_amount;
        }
      }
      const percent = calcRevenuePercent(formatData[0]?.contract_type);
      setAffiliateStats({
        numOfDeal: deal,
        numOfLead: lead,
        actualRevenue,
        revenue: percent * actualRevenue / 100
      });
    }
  }, [affiliateData, calcRevenuePercent]);

  return (
    <>
      {currentTab === 'member' && (
        <tr>
          <td>{`AFF_${affiliate?.affiliate_id}`}</td>
          <td>{affiliate?.full_name}</td>
          <td>{affiliateStats.numOfDeal}</td>
          <td>{formatCurrency(affiliateStats.actualRevenue) || 0}</td>
          <td>{formatCurrency(affiliateStats.revenue) || 0}</td>
        </tr>
      )}
      {currentTab === 'lead' && (
        <tr>
          <td>{`AFF_${affiliate?.affiliate_id}`}</td>
          <td>{affiliate?.full_name}</td>
          <td>{formatCurrency(affiliateStats.actualRevenue) || 0}</td>
          <td>{affiliateStats.numOfDeal}</td>
          <td>{affiliateStats.numOfLead}</td>
          <td>{formatCurrency(affiliateStats.revenue) || 0}</td>
        </tr>
      )}
    </>
  )
}

export default RevenueItem;
